export default __webpack_public_path__ + "static/media/trash.86a58ab7.svg";